import { EMBED_PREFIX } from '../../app/Routes';

export const getIsEmbedded = () => {
  return window.location.pathname.includes(`/${EMBED_PREFIX}/`);
};
